exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pattern-gallery svg{width:300px;height:200px}.pattern-gallery polygon{stroke:#333;stroke-width:.15}.pattern-gallery path,.pattern-gallery rect{fill:none;stroke:#333;stroke-width:.15}.link:hover{.caption-container{background-color:rgba(69,117,143,.8)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-1d68c87e","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/client/components/PatternGallery.vue
// module id = 527
// module chunks = 1